import { ModalData, ReducerAction, ReducerHandler } from '../../Types';
import { StoreModal } from '../../Types/StoreTypes';
import {
    SET_THEME_MODAL_STATE,
    SET_DEMO_MODAL_STATE,
    SET_MODAL,
    SET_FILE_DLP_MODAL_STATE,
} from '../Actions/modalActions';
import { ButtonVariant, ModalSizes } from '../../Types/Enums';

const initialState = {
    themeModalState: 'closed',
    demoModalState: 'closed',
    fileDlpModalState: {
        state: 'closed',
        files: [],
        combinedDlp: null,
        callback: null,
    },
    modal: {
        state: 'closed',
        title: '',
        content: '',
        buttonRightText: null,
        buttonRightAction: null,
        buttonRightVariant: ButtonVariant.primary,
        showRightButton: true,
        buttonLeftText: null,
        buttonLeftAction: null,
        buttonLeftVariant: ButtonVariant.secondary,
        showLeftButton: true,
        modalSize: ModalSizes.medium,
        closeOnAction: false,
        showCloseButton: true,
        closeFunction: null,
        customButtons: [],
    } as ModalData,
} as StoreModal;

const modalReducerMap: Record<string, ReducerHandler<StoreModal>> = {
    [SET_THEME_MODAL_STATE]: (state, action) => ({ ...state, themeModalState: action.payload }),
    [SET_DEMO_MODAL_STATE]: (state, action) => ({ ...state, demoModalState: action.payload }),
    [SET_FILE_DLP_MODAL_STATE]: (state, action) => ({ ...state, fileDlpModalState: action.payload }),
    [SET_MODAL]: (state, action) => ({
        ...state,
        modal: {
            ...state.modal,
            ...action.payload,
        },
    }),
};

function modalReducer(state = initialState, action: ReducerAction): StoreModal {
    const handler = modalReducerMap[action.type];
    return handler ? handler(state, action) : state;
}

export default modalReducer;
